export class UserAlertSummary {
    userId: string;
    fullName: string;
    imageUrl: string;
    title: string;
    initials: string;
}